import React, { useEffect, useState, useCallback, useMemo } from "react";
import { fetchAccountBUUseCaseDescription } from "../../../../services/accIqService";
import { useParams } from "react-router-dom";
import "../../genericComponents/sideCardTab.css";
import SolutionsAccordionProducts from "./accordianForNudge/solutionsAccordion";
import ProjectionsCards from "./contactsForNudge/projectionsCard";
import InsightsContainer from "./contactsForNudge/insightsContainer";
import NudgeDetailsContainer from "./contactsForNudge/nudgeDetailsContainer";

function OverviewNudgeComp({ nudgeData, businessUnit }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const { accountName, clientName } = useParams();

  const toggleExpand = useCallback(() => {
    setIsExpanded(!isExpanded);
  }, [isExpanded]);

  if (!nudgeData) return null;

  return (
    <div className="container-fluid p-0">
      <div className="card border-0 rounded-3 overflow-hidden mb-4">
        <div>
          <NudgeDetailsContainer
            nudgeData={nudgeData}
            isExpanded={isExpanded}
            toggleExpand={toggleExpand}
          />
          <InsightsContainer
            impact_to_account={nudgeData?.potential_impact}
            accountName={accountName}
            relevance_to_seller={nudgeData?.relevance_to_seller}
            clientName={clientName}
            impact_score={nudgeData?.impact_score}
            opportunity_size={nudgeData?.opportunity_size}
          />

          {/* <ProjectionsCards nudgeData={nudgeData}/> */}

          <SolutionsAccordionProducts
            solutions={nudgeData.relevant_solutions}
          />
        </div>
      </div>
    </div>
  );
}

export default React.memo(OverviewNudgeComp);
